import { useState, useEffect, useRef } from "react";
import moment from "moment";

function CountUp({ end, duration = 2000, suffix = "", decimals = 0 }) {
  const [val, setVal] = useState(0);
  const [started, setStarted] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) setStarted(true); },
      { threshold: 0.3 }
    );
    const el = ref.current;
    if (el) obs.observe(el);
    return () => obs.disconnect();
  }, []);

  useEffect(() => {
    if (!started) return;
    const start = performance.now();
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      setVal(parseFloat((p * end).toFixed(decimals)));
      if (p < 1) requestAnimationFrame(tick);
      else setVal(end);
    };
    requestAnimationFrame(tick);
  }, [started, end, duration, decimals]);

  return <span ref={ref}>{val.toLocaleString("pt-BR", { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}{suffix}</span>;
}

function Stats() {
  const days = moment().diff("2024-12-23", "days");

  return (
    <div
      id="stats"
      className="d-flex align-items-center justify-content-center py-5"
    >
      <div className="container py-5">
        <h1 className="mb-5">Estatísticas do nosso amor</h1>
        <div className="stats-grid">
          <div className="stat-item">
            <h2><CountUp end={days} duration={2500} /></h2>
            <h4>dias juntos</h4>
          </div>
          <div className="stat-item">
            <h2><CountUp end={3.8} duration={2200} decimals={1} suffix="mi" /></h2>
            <h4>minutos de pipipi, pópópó</h4>
          </div>
          <div className="stat-item">
            <h2>1</h2>
            <h4>pedido de casamento</h4>
          </div>
          <div className="stat-item">
            <h2>∞<sup>5</sup></h2>
            <h4>o quanto te amo</h4>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Stats;
